import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import {Tree} from '../../form/tree';
import {loadComponentById} from "../../../utils/components";
import isEqual from "lodash-es/isEqual";
import Figures from "../../form/Figures";
import UrlField from "../../form/UrlField";

class ProgramCategoryForm extends React.Component {

    state = {
        category: null
    }

    formatTreeData = (items) => {
        return (items || []).map((item) => {
            item = {...item};
            item.key = item.id;
            item.label = item.name;
            item.leaf = Array.isArray(item.children) && item.children.length === 0;
            if(item.children) {
                item.children = this.formatTreeData([...(item.children || [])]);
            }
            return item;
        });
    };

    findChild = (category, id) => {
        if (category.id + "" === "" + id) {
            return category;
        }
        return (category.children || []).find((category) => {
            if (category.id + "" === "" + id) {
                return category;
            } else {
                return this.findChild(category);
            }
        });
    }

    loadOnExpand = async (event) => {
        if (!Array.isArray(event.node.children)) {
            await this.props.processAction(async () => {
                const category = this.findChild(this.state.category, event.node[this.props.componentConfig.idfield]);
                const data = await loadComponentById(this.props.componentConfig.componentname, event.node[this.props.componentConfig.idfield], ["children"]);
                category.children = data.children;
                this.setState({category: this.state.category});
                return false;
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {category: this.props.values};
    }

    componentDidUpdate(prevProps, prevState, prevContext)
    {
        if (!isEqual(prevProps.values[this.props.componentConfig.idfield], this.props.values[this.props.componentConfig.idfield])) {
            this.setState({category: this.props.values});
        }
    }

    render() {
        const parentProps = {...this.props.getFieldProps("parent")};
        const treeValue = this.formatTreeData([{...this.state.category}]);
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10">
                        <TextInput name="name" value={this.props.values.name} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-8">
                        <Select
                            name="parent"
                            component="ProgramCategory"
                            objectValue={false}
                            valueKey={"id"}
                            labelKey="name"
                            storeType="remote"
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.parent}
                            {...this.props.getFieldProps("parent")}
                            label="Szülőkategória"
                            isClearable={true}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput name="position" value={this.props.values.position} label="Szülőkategórián belüli pozíció" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("position")}/>
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.cover_image && <div className="row form-row">
                    <div className="col-md-12">
                        <Figures name="figures" label="Képek" componentConfig={this.props.componentConfig} data={this.props.values} />
                    </div>
                </div>}
                {this.props.componentConfig.fielddefs.url &&
                <UrlField {...this.props}/>}
                {/*<Tree value={treeValue} {...parentProps} selectionMode="single" onExpand={this.loadOnExpand} selectionKeys={this.props.values.parent instanceof Object ? this.props.values.parent[this.props.componentConfig.idfield] : this.props.values.parent} onSelect={(event) => {
                    this.props.setFieldValue("parent", event.node[this.props.componentConfig.idfield]);
                }} loading={parentProps.disabled}/>*/}
            </form>
        );
    }
}

export default createForm(ProgramCategoryForm);
